import React from 'react'

const ShipmentInsurance = () => {
    return (
        <>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                version="1.1"
                xmlnsXlink="http://www.w3.org/1999/xlink"
                width={40}
                height={40}
                x={0}
                y={0}
                viewBox="0 0 512 512"
                style={{ enableBackground: "new 0 0 512 512" }}
                xmlSpace="preserve"
                className=""
            >
                <g>
                    <path
                        d="M504.5 49.399v227.034a41.93 41.93 0 0 1-12.269 29.629l-73.215 73.215a41.945 41.945 0 0 1-12.269 8.494L363.912 157.96c-8.744-46.909 16.843-93.468 61.129-111.235l67.19-26.955c7.58 7.58 12.269 18.052 12.269 29.629z"
                        style={{}}
                        fill="#ffbd69"
                        data-original="#ffbd69"
                    />
                    <path
                        d="m278.591 80.293-154.371 24.98a41.753 41.753 0 0 0-3.765 17.34V225.4l144.497 166.146h124.435a41.735 41.735 0 0 0 17.36-3.775V105.273l-128.156-24.98z"
                        style={{}}
                        fill="#ffdaaa"
                        data-original="#ffdaaa"
                        className=""
                    />
                    <path
                        d="M278.742 308.22c0-22.043-16.494-40.451-38.386-42.82-28.526-3.062-54.769-13.445-76.994-30.16-11.715-8.826-27.263-12.896-42.907-9.84v166.146h144.497a256.538 256.538 0 0 0 13.79-83.115v-.211z"
                        style={{}}
                        fill="#ffcd8d"
                        data-original="#ffcd8d"
                    />
                    <path
                        d="M253.641 308.431v-.211c0-9.157-6.868-16.878-15.964-17.862-32.514-3.491-63.177-15.332-89.42-35.071a28.8 28.8 0 0 0-15.079-5.702c-49.862 76.898-49.947 180.826-2.437 254.912 10.507-.035 21.026-3.365 29.875-10.017 58.619-43.96 93.025-112.935 93.025-186.049z"
                        style={{}}
                        fill="#48ce7c"
                        data-original="#48ce7c"
                    />
                    <path
                        d="M133.178 249.585a29.084 29.084 0 0 0-20.073 5.943c-26.15 20.113-56.85 31.893-89.43 35.031-9.17.883-16.175 8.617-16.175 17.872 0 73.205 34.469 142.132 93.024 186.049a49.906 49.906 0 0 0 30.216 10.017c-33.749-74.128-31.56-178.056 2.438-254.912z"
                        style={{}}
                        fill="#1dc153"
                        data-original="#1dc153"
                    />
                    <path
                        d="M312.467 105.273v61.387c0 11.396-12.882 18.023-22.159 11.396l-18.565-13.253a14.01 14.01 0 0 0-16.296 0l-18.555 13.253c-9.277 6.627-22.159 0-22.159-11.396v-61.387l52.311-17.618 45.423 17.618zM462.602 7.5h-52.13l-32.05 13.918c-34.911 15.112-58.966 46.695-65.955 83.855h94.279l85.484-85.504C484.65 12.189 474.178 7.5 462.602 7.5z"
                        style={{}}
                        fill="#ffcd8d"
                        data-original="#ffcd8d"
                    />
                    <path
                        d="m312.728 7.5-30.121 60.242-67.873 37.531H124.22a42.01 42.01 0 0 1 8.504-12.289l73.235-73.215A41.924 41.924 0 0 1 235.578 7.5h77.15z"
                        style={{}}
                        fill="#ffcd8d"
                        data-original="#ffcd8d"
                    />
                    <path
                        d="m410.472 7.5-98.005 97.773h-97.733L312.728 7.5z"
                        style={{}}
                        fill="#ffbd69"
                        data-original="#ffbd69"
                    />
                    <path
                        d="M197.585 352.639c6.795-6.795 6.808-17.842 0-24.649-6.807-6.807-17.842-6.807-24.649 0l-66.219 66.229c-9.518 13.315-6.734 25.46 3.194 36.707a29.883 29.883 0 0 0 18.004-8.617l69.67-69.67z"
                        style={{}}
                        fill="#ebebf9"
                        data-original="#ebebf9"
                    />
                    <path
                        d="m106.689 394.246-18.484-18.484c-6.795-6.794-17.841-6.808-24.649 0-6.807 6.807-6.807 17.842 0 24.639l21.908 21.908c6.685 6.685 15.731 9.553 24.446 8.617-1.701-11.846-2.784-24.115-3.194-36.707l-.027.027z"
                        style={{}}
                        fill="#deddf5"
                        data-original="#deddf5"
                    />
                    <path
                        d="M406.75 217.02v170.76M124.21 105.27h282.54v76.75"
                        style={{
                            strokeWidth: 15,
                            strokeLinecap: "round",
                            strokeLinejoin: "round",
                            strokeMiterlimit: 10
                        }}
                        fill="none"
                        stroke="#000000"
                        strokeWidth={15}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeMiterlimit={10}
                        data-original="#000000"
                        className=""
                    />
                    <path
                        d="M120.455 251.412V122.613c0-11.486 4.699-22.039 12.269-29.629l73.235-73.215A41.924 41.924 0 0 1 235.578 7.5h227.024c23.153 0 41.899 18.755 41.899 41.899v227.034a41.93 41.93 0 0 1-12.269 29.629l-73.215 73.215a41.977 41.977 0 0 1-29.629 12.269H238.28M312.728 7.5l-97.994 97.773M410.472 7.5l-98.005 97.773"
                        style={{
                            strokeWidth: 15,
                            strokeLinecap: "round",
                            strokeLinejoin: "round",
                            strokeMiterlimit: 10
                        }}
                        fill="none"
                        stroke="#000000"
                        strokeWidth={15}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeMiterlimit={10}
                        data-original="#000000"
                        className=""
                    />
                    <path
                        d="M312.467 105.273v61.387c0 11.396-12.882 18.023-22.159 11.396l-18.565-13.253a14.01 14.01 0 0 0-16.296 0l-18.555 13.253c-9.277 6.627-22.159 0-22.159-11.396v-61.387M492.231 19.769l-85.484 85.504M73.68 470.91c8.26 8.47 17.22 16.36 26.84 23.57 17.98 13.5 42.5 13.22 60.1 0 58.72-44.04 93.02-113.07 93.02-186.05v-.21c0-9.16-6.87-16.88-15.96-17.86-32.52-3.49-63.18-15.34-89.42-35.07-10.5-7.91-24.94-7.64-35.16.24-26.15 20.11-56.85 31.89-89.42 35.03-9.18.88-16.18 8.62-16.18 17.87 0 49.29 15.62 96.63 43.7 135.7"
                        style={{
                            strokeWidth: 15,
                            strokeLinecap: "round",
                            strokeLinejoin: "round",
                            strokeMiterlimit: 10
                        }}
                        fill="none"
                        stroke="#000000"
                        strokeWidth={15}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeMiterlimit={10}
                        data-original="#000000"
                        className=""
                    />
                    <path
                        d="m88.205 375.762 18.484 18.484 66.247-66.257c6.807-6.807 17.842-6.807 24.649 0 6.795 6.795 6.808 17.841 0 24.649l-69.67 69.67c-11.727 11.727-30.724 11.727-42.451 0L63.556 400.4c-6.807-6.797-6.807-17.832 0-24.639 6.795-6.794 17.842-6.806 24.649.001zM215.648 217.103c0-7.631-6.185-13.816-13.816-13.816-7.641 0-13.826 6.185-13.826 13.816M311.554 217.103c0-7.631 6.185-13.816 13.816-13.816s13.826 6.185 13.826 13.816M248.942 233.258c7.765 8.925 21.568 8.907 29.318 0"
                        style={{
                            strokeWidth: 15,
                            strokeLinecap: "round",
                            strokeLinejoin: "round",
                            strokeMiterlimit: 10
                        }}
                        fill="none"
                        stroke="#000000"
                        strokeWidth={15}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeMiterlimit={10}
                        data-original="#000000"
                        className=""
                    />
                </g>
            </svg>

        </>
    )
}

export default ShipmentInsurance